var focusInvalidField = (e, errors) => {
  var field = e.currentTarget.querySelector(`[name='${errors[0].field}']`);

  if (field) {
    field.focus();
  }
};
var parseErrorCode = altapayEvent => {
  var _altapayEvent$_errorD, _altapayEvent$_errorD2;

  var errorCode = (_altapayEvent$_errorD = (_altapayEvent$_errorD2 = altapayEvent._errorDetails) == null ? void 0 : _altapayEvent$_errorD2.merchantErrorCode) != null ? _altapayEvent$_errorD : ""; // All errorCodes in format 23NNNN

  var aquirerDeclineRegex = /^23\d{4}$/;

  switch (true) {
    case aquirerDeclineRegex.test(errorCode):
      return "AQUIRER_DECLINE";

    default:
      return "PLACE_ORDER_CATCH";
  }
};

export { focusInvalidField, parseErrorCode };
//# sourceMappingURL=utils.js.map
